export { default as ProductTypeEditTemplate } from './ProductTypeEditTemplate';
export { default as ProductTypeListTemplate } from './ProductTypeListTemplate';
